export default "__VITE_ASSET__BxkwRqdZ__";